var map = {
	"./API_Flow.PNG": 722,
	"./Back_icon.svg": 1513,
	"./Currency.svg": 4764,
	"./Data_Model.PNG": 6765,
	"./Dataflows.PNG": 1412,
	"./Dataprep.png": 412,
	"./DownArrow.svg": 7601,
	"./Heart.svg": 8709,
	"./Home_icon.svg": 970,
	"./Intro.PNG": 3486,
	"./Job_Scheduler.PNG": 3012,
	"./Layer_1.png": 6078,
	"./Lightbulb.svg": 1531,
	"./Play_Btn.svg": 5766,
	"./ReportMiner.PNG": 9934,
	"./SpeakerPhone.svg": 3499,
	"./Workflow.PNG": 9011,
	"./astera-community .svg": 5331,
	"./asteraLogo.png": 8603,
	"./cardPlaceholder.png": 2171,
	"./documentation.png": 1260,
	"./feedBack.png": 8615,
	"./final.svg": 1226,
	"./interactiveDemo.png": 4039,
	"./step1.svg": 7821,
	"./step2.svg": 127,
	"./step3.svg": 1257,
	"./step4.svg": 8201,
	"./step5.svg": 3310,
	"./supportInfo.png": 6357,
	"./userTestimonial.png": 9412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;